






















import Vue from 'vue'
import BaseImage from '@/common/components/BaseImage.vue'
import NativeBaseImage from '@/common/components/NativeBaseImage.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'

const COLOR_CODES: {[key: string]: string} = {
  ['women']: '#DB1D4B',
  ['men']: '#4A90E2',
  ['unisex']: '#666',
  ['kids']: '#F5A623'
}

export default Vue.extend({
  components: {
    BaseImage,
    NativeBaseImage
  },
  props: {
    gender: {
      type: String,
      required: true
    },
    useNativeLazy: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    genderKey(): string {
      return this.gender.split('=')[0] || ''
    },
    genderName(): string {
      return this.gender.split('=')[1] || ''
    },
    genderIcon(): string {
      return this.genderKey
        ? require(`common/search/icon-${this.genderKey}.svg`)
        : ''
    },
    genderLabelStyle(): { [key: string]: string } {
      return {
        '--comp-label-color': COLOR_CODES[this.genderKey]
      }
    }
  }
})
